var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9863 8.86278L9.94141 0.823715C9.88348 0.765676 9.81468 0.71963 9.73894 0.688213C9.66319 0.656796 9.582 0.640625 9.5 0.640625C9.418 0.640625 9.33681 0.656796 9.26106 0.688213C9.18532 0.71963 9.11652 0.765676 9.05859 0.823715L1.01367 8.86278C0.779297 9.09715 0.646484 9.41551 0.646484 9.74754C0.646484 10.437 1.20703 10.9975 1.89648 10.9975H2.74414V16.7339C2.74414 17.0796 3.02344 17.3589 3.36914 17.3589H8.25V12.9839H10.4375V17.3589H15.6309C15.9766 17.3589 16.2559 17.0796 16.2559 16.7339V10.9975H17.1035C17.4355 10.9975 17.7539 10.8667 17.9883 10.6304C18.4746 10.1421 18.4746 9.35106 17.9863 8.86278Z",
    fill: "#307BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ad037de4.svg";
export { ForwardRef as ReactComponent };